/* eslint-disable import/prefer-default-export */

import React from 'react';

export enum BreakpointKey {
  BREAKPOINT_CONTENT = 'breakpointContent',
  BREAKPOINT_MOBILE = 'breakpointMobile',
  BREAKPOINT_TABLET = 'breakpointTablet',
  BREAKPOINT_TABLET_MOBILE = 'breakpointTabletMobile',
  BREAKPOINT_TINY_MOBILE = 'breakpointTinyMobile'
}

export type BreakpointContextValue = {
  [w in 'maxWidth' | 'minWidth']: {
    [b in BreakpointKey]: boolean
  }
}

export declare const useBreakpoint: () => BreakpointContextValue;
export declare const BreakpointProvider: (children: React.Element) => JSX.Element;
